import { useState, useEffect } from "react";
import { Input } from "antd";
import { ChantButton } from "../../../../CommonComponents";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../../store/adminData/adminData";
import { startUpdateUser } from "../../../../redux/actions/user";
import fakeDispatch from "../../../../utils/fakeDispatch";
import { db } from "../../../../services/firebaseService/connection";
import { doc, updateDoc } from "@firebase/firestore";
import {
  GUIDE_ENGAGE,
  TOPIC_ADD_LEADERBOARD_REWARDS,
} from "../../../../constants/gettingStarted";
import { setGettingStartedItemStatus } from "../../../../redux/actions/adminData";
import { postUpdateCDNUtil } from "../../../../helperFunctions/util";

const Leaderboard = () => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];

  const groupData = adminData?.data || {};

  const [rewards, setRewards] = useState({
    eventLeaderboard: (groupData.rewards || {}).eventLeaderboard || "",
    scoreLeaderboard: (groupData.rewards || {}).scoreLeaderboard || "",
    statsLeaderboard: (groupData.rewards || {}).statsLeaderboard || "",
  });
  const [loading, setLoading] = useState(false);

  const checkGettingStartedStatus = (data) => {
    if (data?.rewards && Object.values(data?.rewards)?.length > 0) {
      fakeDispatch(
        setGettingStartedItemStatus(
          currentGroup,
          GUIDE_ENGAGE,
          TOPIC_ADD_LEADERBOARD_REWARDS,
          true
        )
      );
    }
  };

  // Sync rewards from store when group changes
  useEffect(() => {
    const gd = adminData?.data || {};
    setRewards({
      eventLeaderboard: (gd.rewards || {}).eventLeaderboard || "",
      scoreLeaderboard: (gd.rewards || {}).scoreLeaderboard || "",
      statsLeaderboard: (gd.rewards || {}).statsLeaderboard || "",
    });
    checkGettingStartedStatus(gd);
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (e) => {
    setRewards((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const save = async () => {
    setLoading(true);
    await updateDoc(doc(db, "group", currentGroup), { rewards }).then(() => {
      postUpdateCDNUtil(currentGroup);
      setLoading(false);
    });
    fakeDispatch(startUpdateUser());
  };

  let primaryColor = "";
  if (adminData?.data?.configuration?.primaryColor) {
    const { r, g, b } = adminData.data.configuration.primaryColor;
    primaryColor = `rgb(${r}, ${g}, ${b})`;
  }

  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#ffffff", marginTop: "2px" }}>
      <div className="chant-form-body p-3">
        <p>
          Groups can offer awards for event attendance, score predictions
          and (when available) stat predictions. Add rewards below to appear
          in the Leaderboard cards. Consider end of season prizes for the
          top 5-10 members (or enter the top &apos;x&apos; into an end of
          season drawing).
        </p>

        <div style={{ marginTop: "24px", marginBottom: "16px" }}>
          <span style={{ fontSize: 20, fontWeight: "bold" }}>
            Event Leaderboard Rewards
          </span>
          <p style={{ marginTop: "4px", color: "#595959" }}>
            Set points by event when creating watch parties, tailgates,
            volunteer, travel and special events. Enter rewards offered to
            leaders at the end of the season.
          </p>
          <Input.TextArea
            rows={3}
            maxLength={250}
            value={rewards.eventLeaderboard}
            onChange={handleInputChange}
            name="eventLeaderboard"
            placeholder="Max 250 characters."
            tabIndex="2"
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <span style={{ fontSize: 20, fontWeight: "bold" }}>
            Score Leaderboard Rewards
          </span>
          <p style={{ marginTop: "4px", color: "#595959" }}>
            Enter rewards offered to leaders at the end of the season.
          </p>
          <Input.TextArea
            rows={3}
            maxLength={250}
            value={rewards.scoreLeaderboard}
            onChange={handleInputChange}
            name="scoreLeaderboard"
            placeholder="Max 250 characters."
            tabIndex="2"
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <span style={{ fontSize: 20, fontWeight: "bold" }}>
            Stats Leaderboard Rewards
          </span>
          <p style={{ marginTop: "4px", color: "#595959" }}>
            Available for leagues that provide full match stats (possession,
            shots, etc). Enter rewards offered to leaders at the end of the
            season.
          </p>
          <Input.TextArea
            rows={3}
            maxLength={250}
            value={rewards.statsLeaderboard}
            onChange={handleInputChange}
            name="statsLeaderboard"
            placeholder="Max 250 characters."
            tabIndex="2"
          />
        </div>

        <div className="d-flex justify-content-center mt-4">
          <ChantButton
            style={{
              backgroundColor: primaryColor,
              borderColor: primaryColor,
              width: "10rem",
            }}
            tabIndex="14"
            loading={loading}
            onClick={save}
          >
            Save
          </ChantButton>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
